module.exports = __webpack_public_path__ + "img/3ds_VbV_refus_57.87d67afb.png";